import ExpectedAnswerList from './expectedanswerlist'

export default ExpectedAnswerList